export class GeoPosition {
  lat: number;
  lng: number;
}
